import { useEffect } from "react";
import Navbar from "../components/sections/Navbar";
import Hero from "../components/sections/Hero";
import Team from "../components/sections/Team";
import ServiceHours from "../components/sections/ServiceHours";
import Poliklinik from "../components/sections/Poliklinik";
import RawatInap from "../components/sections/RawatInap";
import Grooming from "../components/sections/Grooming";
import WaitingArea from "../components/sections/WaitingArea";
import Testimonials from "../components/sections/Testimonials";
import Location from "../components/sections/Location";
import FinalCTA from "../components/sections/FinalCTA";
import Footer from "../components/sections/Footer";

export default function PikkoLanding() {
  useEffect(() => {
    document.title =
      "Pikko Pet Care — Compassionate Care, Happy Pets · Jatiasih Bekasi";
  }, []);

  return (
    <main data-testid="pikko-landing" className="min-h-screen bg-[var(--pikko-cream)] text-[var(--pikko-brown-ink)]">
      <Navbar />
      <Hero />
      <Team />
      <ServiceHours />
      <Poliklinik />
      <RawatInap />
      <Grooming />
      <WaitingArea />
      <Testimonials />
      <Location />
      <FinalCTA />
      <Footer />
    </main>
  );
}
